export enum ResourceType {
  Campaign = 'campaign',
  Journey = 'journey',
  List = 'list',
  Template = 'template',
}
